import {Component, OnInit, AfterViewInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import "jquery-serializejson";
import "jquery-validation";
import {IClientModel} from "../../models/clients/clients.model";
import {DebtsModel, TimelineModel} from "../../models/debts/debts.model";
import {DebtsService} from "../../models/debts/debts.service";
import {ClientAccountsService} from "../../models/client-accounts/client-accounts.service";
import {ClientAccountsModel} from "../../models/client-accounts/client-accounts.model";
import {InvoiceModalComponent} from "./invoice-modal/invoice-modal.component";
import {ClientsService} from "../../models/clients/clients.service";
import {ManagePaymentsModalComponent} from "./manage-payments-modal/manage-payments-modal.component";
import {BatchPaymentsService} from "../../models/batch-payments/batch-payments.service";
import {VoidModalComponent} from './void-modal/void-modal.component';
import {RemoveModalComponent} from './remove-modal/remove-modal.component';
import {ClientProcessorsService} from '../../models/client-processors/client-processors.service';
import {ProcessorsService} from '../../models/processors/processors.service';
import {CloseDebtAccountModalComponent} from "./close-debt-account/close-debt-account.component";
import {SelectStatementsModalComponent} from "./select-statements/component";
import {DebtAccount} from "../../models/clients/clients.type";
import {PermissionsService} from "../../services/permissions/permissions.service";
import {PricingsService} from '../../models/pricings/pricings.service';

class ChargeBodyModel {
    amount: number = 0;
    reason: string = '';
    payment_date: string = '';
}

class TopUp {
    time: string;
    repaid: number;
    computed = 0
}

declare let $:JQueryStatic | any;

@Component({
    selector: 'debt-account',
    templateUrl: 'debt-account.template.html',
    styleUrls: ['debt-account.css']
})

export class DebtAccountComponent implements OnInit, AfterViewInit {

    public debt = new DebtsModel();

    public client = <IClientModel> {};
    public clientId:number;
    public topupsShowed = false;
    public chargeDebtShowed = false;

    public timeline = <TimelineModel[]> [];
    public processors = <any[]> [];

    public chargeTransaction = new ChargeBodyModel();

    public selectedProcessorId = null;

    public topup = new TopUp();

    public clientForPayments;

    public closedAccount = false;

    public isApplyTopupConfirm = false;

    public isTopupDisabled = true;
    public isTopupDisabledInProcess: boolean = null;

    public topupInProcess = false;

    constructor(
        private clientAccountsService:ClientAccountsService,
        private clientsService:ClientsService,
        private processorsService: ProcessorsService,
        private debtsService:DebtsService,
        private batchPaymentsService:BatchPaymentsService,
        private route:ActivatedRoute,
        private router:Router,
        public permissionsService: PermissionsService,
        public pricingsService: PricingsService,
        private modalService:NgbModal
    ) {


    }

    ngOnInit() {
        this.clientId = this.route.snapshot.parent.parent.params['clientId'] ||
            this.route.snapshot.parent.params['clientId'] ||
            this.route.snapshot.params['clientId'];

        if (this.clientId) {
            this.loadData();
            return;
        }
        let pricing_id = this.route.snapshot.parent.parent.params['pricingId'] ||
            this.route.snapshot.parent.params['pricingId'] ||
            this.route.snapshot.params['pricingId'];
        
        if (! pricing_id) throw 'Client or Pricing ID not found';

        this.pricingsService.getOne(pricing_id)
            .subscribe((res) => {
                this.clientId = res.data.client_id;
                this.loadData();
            });
    }

    ngAfterViewInit() {

    }


    // ===========================================================
    // Functions
    // ===========================================================

    loadTimeline() {
        this.debtsService.getTimeline(this.debt.id)
            .subscribe((res) => {
                //this.timeline = res.data.reverse();
                this.timeline = res.data;
            });
    }


    loadData() {

        this.debtsService.getOneByClient(this.clientId)
            .subscribe((res) => {
                this.debt = res.data;

                if (this.debt.status == DebtAccount.CLOSED) {
                    this.closedAccount = true;
                }

                this.updateTopup();

                this.loadTimeline();

                this.batchPaymentsService.getOne(this.debt.id)
                    .subscribe((res) => {
                        this.client = res.data;
                    });
            });


        this.processorsService.getListByClient(this.clientId)
            .subscribe((res) => {
                this.processors = res.data;
            });

        this.batchPaymentsService.getList()
            .subscribe((res) => {
                let client = res.data.filter(item => {
                    if(item.id == this.clientId) return true;
                });

                this.clientForPayments = client[0];
            })

        this.clientsService.getTopupDisabled(this.clientId)
            .subscribe((res) => {
                this.isTopupDisabled = res.data.is_disabled;
                this.isTopupDisabledInProcess = false;
            });

    }

    updateTopup() {
        const pricing = this.debt.pricing;
        let topupIndex = 0;

        if (pricing.topup_1_applied == 0) {
            topupIndex = 1;
        } else if (pricing.topup_2_applied == 0) {
            topupIndex = 2;
        } else if (pricing.topup_3_applied == 0) {
            topupIndex = 3;
        }


        this.topup = new TopUp();

        if (topupIndex) {
            this.topup.time = pricing[`topup_${topupIndex}_time`];
            this.topup.repaid = pricing[`topup_${topupIndex}_repaid`];
            this.topup.computed = pricing[`topup_${topupIndex}_computed`];
        }
    }


    // ===========================================================
    // Actions
    // ===========================================================


    public setFunded() {

    }

    get canTurnTopup(): boolean {
        return this.permissionsService.can('turnTopupState.change');
    }

    public applyTopup() {
        if (this.isTopupDisabled || this.isTopupDisabledInProcess || this.isTopupDisabledInProcess === null || this.topupInProcess) return;
        this.topupInProcess = true;
        this.debtsService.applyTopup(this.debt.id)
            .subscribe((res) => {
                this.topupInProcess = false;
                this.debt = res.data;

                this.updateTopup();

                this.hideApplyTopupConfirm();
            });
    }

    public showApplyTopupConfirm() {
        this.isApplyTopupConfirm = true;
    }

    public hideApplyTopupConfirm() {
        this.isApplyTopupConfirm = false;
        this.topupsShowed = false;
    }

    getTopupTurnBtnName() {
        return this.isTopupDisabled ? 'Turn On Edit Topups' : 'Turn Off Edit Topups';
    }

    turnTopupState() {
        this.isTopupDisabledInProcess = true;
        this.clientsService.turnTopupState(this.clientId)
            .subscribe((res) => {
                this.isTopupDisabled = res.data.is_disabled;
                this.isTopupDisabledInProcess = false;

                if (this.isTopupDisabled) this.hideApplyTopupConfirm();
            }, () => {
                this.isTopupDisabledInProcess = false;
            });
    }

    public showInvoice() {
        const modalRef = this.modalService.open(InvoiceModalComponent);
        modalRef.componentInstance.client = this.client;
        modalRef.componentInstance.debt = this.debt;
    }

    public showStatements(period: any = null) {
        let url: any = '/statements/' + this.debt.id;
        let _a: any = document.createElement('a');
        _a.href = url;
        url = new URL(_a);
        if (period) {
            url.searchParams.set('from', period['from']);
            url.searchParams.set('to', period['to']);
        }
        window.open(url.href, '_blank');
    }

    showSelectStatements() {
        let modalRef = this.modalService.open(SelectStatementsModalComponent);

        modalRef.result
            .then(res => {
                this.showStatements(res);
            })
            .catch(e => {
            });
    }

    timelineFilterValue: any = null;
    timelineFilter: any = null;

    setTimelineFilter() {
        let period: any = this.timelineFilterValue;

        let drop_time = (date: any) => {
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            date.setMilliseconds(0);
        };
        let start_last_month = (date: any) => {
            drop_time(date);
            date.setDate(-1);
            date.setDate(1);
        };
        let start_next_month = (date: any) => {
            drop_time(date);
            date.setDate(1);
            date.setDate(32);
            date.setDate(1);
        };
        let start_last_year = (date: any) => {
            drop_time(date);
            date.setMonth(-1);
            date.setMonth(0)
            date.setDate(1);
        };
        let start_next_year = (date: any) => {
            drop_time(date);
            date.setMonth(12);
            date.setDate(1);
        };

        let result: any;
        if (period == 'm') {
            var t0 = new Date();
            start_last_month(t0);
            start_next_month(t0);
            var t1 = new Date(t0);
            start_next_month(t1);
            result = {
                'from': t0,
                'to': t1        
            };
        } else if (period == 'y') {
            var t0 = new Date();
            start_last_year(t0);
            start_next_year(t0);
            var t1 = new Date(t0);
            start_next_year(t1);
            result = {
                'from': t0,
                'to': t1        
            };
        } else {
            result = null;
        }

        this.timelineFilter = result;

        console.log(this.timelineFilter);
    }

    inTimelineFilter(date: any): any {
        if (! this.timelineFilter) return true;
        try {
            let d: any = new Date('' + date + ' 00:00');
            if (! isFinite(d)) return false;
            if (this.timelineFilter['from']) {
                let t0: any = new Date(this.timelineFilter['from']);
                if (! isFinite(t0)) return false;
                if (d < t0) return false;
            }
            if (this.timelineFilter['to']) {
                let t1: any = new Date(this.timelineFilter['to']);
                if (! isFinite(t1)) return false;
                if (d > t1) return false;
            }
        } catch (e) {
            return false;
        }
        return true;
    }

    public closeDebtAccount() {
        const modalRef = this.modalService.open(CloseDebtAccountModalComponent);
        modalRef.componentInstance.accountId = this.debt.id;

        modalRef.result
            .then((res) => {
                this.debtsService.closeAccount(this.debt.id, {close_reason: res})
                    .subscribe((res) => {
                        this.closedAccount = true;
                    });
            })
            .catch(e => {
            });
    }

    public selectProcessor() {

    }

    public managePayments() {
        if (! this.isEnabledManagePayment()) return;
        const modalRef = this.modalService.open(ManagePaymentsModalComponent, {windowClass: 'modal-payment'});
        modalRef.componentInstance.client = this.clientForPayments;
        modalRef.componentInstance.debt = this.debt;

        modalRef.result
            .then((res) => {

            }, (reason) => {
                this.loadData();
            });

    }

    public isEnabledManagePayment() {
        return (this.clientForPayments ? true : false);
    }

    public charge() {

        this.debtsService.charge(this.debt.id, this.chargeTransaction)
            .subscribe((res) => {
                this.chargeTransaction = new ChargeBodyModel();
            })

    }

    public voidPaymentModal(transaction) {
        if (transaction.is_removed || transaction.is_voided) return;
        const modalRef = this.modalService.open(VoidModalComponent);
        modalRef.componentInstance.type = 'payment';
        modalRef.componentInstance.transaction = transaction;
        modalRef.result
            .then((res) => {
                Object.assign(transaction, res);
                //this.loadData();
            });
    }

    public voidLogModal(transaction) {
        if (transaction.is_removed || transaction.is_voided) return;
        const modalRef = this.modalService.open(VoidModalComponent);
        modalRef.componentInstance.type = 'log';
        modalRef.componentInstance.transaction = transaction;
        modalRef.result
            .then((res) => {
                Object.assign(transaction, res);
                //this.loadData();
            });
    }

    public removeModal(transaction, type) {
        const modalRef = this.modalService.open(RemoveModalComponent);
        modalRef.componentInstance.type = type;
        modalRef.componentInstance.transaction = transaction;
        modalRef.result
            .then((res) => {
                Object.assign(transaction, res);
                //this.loadData();
            });
    }

    _in_hide_show_process: any = false;
    showHideCharge(item: any, hide: any) {
        if (this._in_hide_show_process) return;
        this._in_hide_show_process = true;
        this.debtsService.hideShowCharge(item.id, hide)
            .subscribe(
                res => {
                    this._in_hide_show_process = false;
                    item.is_hidden = hide;
                },
                err => {
                    this._in_hide_show_process = false;
                }
            )
        
    }

    get isDebtReady() {
        return this.debt && this.debt.id;
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/debt-account/debt-account.component.ts